import { render, staticRenderFns } from "./LinkToPay.vue?vue&type=template&id=1eca64fd&"
import script from "./LinkToPay.vue?vue&type=script&lang=js&"
export * from "./LinkToPay.vue?vue&type=script&lang=js&"
import style0 from "./LinkToPay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports